import { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

export function useUAParser() {
  const [result, setResult] = useState<UAParser.IResult>({
    browser: {
      name: '',
      major: '',
      version: '',
    },
    device: {
      model: '',
      type: '',
      vendor: '',
    },
    engine: {
      name: '',
      version: '',
    },
    os: {
      name: '',
      version: '',
    },
    cpu: {
      architecture: '',
    },
    ua: '',
  });

  const isMobile = result.device.type === 'mobile';
  const isIphone = result.device.model === 'iPhone';

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const result = new UAParser().getResult();
    setResult(result);
  }, []);

  return { ...result, isMobile, isIphone };
}
